import { render, staticRenderFns } from "./outlayDetail.vue?vue&type=template&id=71d21fde&lang=pug&"
import script from "./outlayDetail.vue?vue&type=script&lang=js&"
export * from "./outlayDetail.vue?vue&type=script&lang=js&"
import style0 from "./outlayDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports